var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"gooey"},[_c('span',{staticClass:"dot"}),_c('div',{staticClass:"dots"},[_c('span'),_c('span'),_c('span')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }